import { Injectable } from '@angular/core';
import { Currency } from './currency';
import { PaymentType } from './payment-type';
import { SchoolInvoiceWithPaymentOrders } from './school-invoice-with-payment-orders';
import Decimal from 'decimal.js';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class SchoolInvoiceService {

  invoices: SchoolInvoiceWithPaymentOrders[] = [];

  // invoice: SchoolInvoice;
  selectedInvoiceId: number | null = null;
  invoiceWithPaymentOrders!: SchoolInvoiceWithPaymentOrders | null;
  currencies: Currency[] = [];
  paymentTypes: PaymentType[] = [];
  index = null;

  constructor() { }

  checkPaymentAmounts(invoiceForm: FormGroup, paymentOrderForms: FormGroup[]){
    if(invoiceForm.get("amount")!.invalid){
      return false;
    }
    let invoiceAmount = new Decimal(invoiceForm.get("amount")!.value);
    let paymentOrderAmount = new Decimal(0);
    for(let orderForm of paymentOrderForms){
      if(orderForm.get("amount")!.invalid){
        return false;
      } else{
        paymentOrderAmount = paymentOrderAmount.plus(new Decimal(orderForm.value.amount));
      }
    }
    return invoiceAmount.equals(paymentOrderAmount);
  }
}
